import React, { useEffect } from "react";
import { Footer } from "../Footer";
import { HomeHeader } from "./Header";
import analytics from "../services/analytics";
import { translation } from "../translations";
import { ArticlesSection } from "./ArticlesSection";
import { Background } from "./Background";
import { BenefitsSection } from "./BenefitsSection";
import { DownloadSection } from "./DownloadSection";
import { StoreRatingSection } from "./StoreRatingSection";
import { TestimonialsSection } from "./TestimonialsSection";
import { PromoVideoSection } from "./PromoVideoSection";
import { SizedBox } from "../SizedBox";

export const Home: React.FC = () => {
  useEffect(() => {
    document.title = translation.landingPageDocumentTitle;
    analytics.logPageView("home");
  }, []);

  return (
    <Background>
      <HomeHeader includeNavigation={true} learnMore={false} />
      <StoreRatingSection />
      <BenefitsSection />
      <DownloadSection />
      <SizedBox desktopHeight={72} />
      <PromoVideoSection />
      <TestimonialsSection />
      <ArticlesSection />
      <Footer />
    </Background>
  );
};

export default Home;
